export default {
	verify: {
		title: "Verificación en dos pasos",
		totpHint: "Introduce el código de 6 dígitos de tu aplicación de autenticación.",
		emailHint: "Enviamos un código de 6 dígitos a tu correo.",
		backupHint: "Introduce uno de tus códigos de respaldo.",
		codeLabel: "Código de verificación",
		backupLabel: "Código de respaldo",
		rememberDevice: "Recordar este dispositivo durante 30 días",
		submit: "Verificar",
		invalidCode: "Código inválido o expirado. Inténtalo de nuevo.",
		resend: "Reenviar código",
		resending: "Reenviando...",
		resent: "Código reenviado a tu correo",
		resendError: "No se pudo reenviar el código",
		useBackup: "Usar un código de respaldo",
		useCodeInstead: "Usar código de la aplicación",
		back: "Volver al inicio de sesión",
	},
	settings: {
		title: "Verificación en dos pasos",
		description:
			"Añade una capa extra de seguridad a tu cuenta exigiendo un código además de la contraseña al iniciar sesión.",
		enabled: "Verificación en dos pasos activada",
		disabled: "Verificación en dos pasos desactivada",
		disabledHint: "Tu cuenta está protegida solo con la contraseña.",
		methodLabel: "Método",
		backupRemaining: "{count} código(s) de respaldo restante(s)",
		activate: "Activar",
		regenerate: "Regenerar códigos de respaldo",
		disable: "Desactivar",
	},
	methods: {
		totp: "Aplicación de autenticación",
		totpDesc: "Usa Google Authenticator, Authy o similar (recomendado).",
		email: "Código por correo",
		emailDesc: "Recibe un código por correo en cada inicio de sesión.",
	},
	activate: {
		title: "Activar la verificación en dos pasos",
		chooseMethod: "Elige cómo quieres recibir los códigos de verificación.",
		continueBtn: "Continuar",
		totpScan:
			"Escanea el código QR con tu aplicación de autenticación e introduce el código generado.",
		totpManual: "O introduce esta clave manualmente:",
		qrAlt: "Código QR para la configuración del autenticador",
		emailSent: "Enviamos un código de verificación a tu correo.",
		confirm: "Activar",
	},
	backup: {
		title: "Códigos de respaldo",
		warning:
			"Guarda estos códigos en un lugar seguro. Cada código puede usarse una sola vez para iniciar sesión si pierdes el acceso a tu método principal. No se mostrarán de nuevo.",
		copy: "Copiar",
		download: "Descargar",
		saved: "Ya guardé mis códigos",
		fileHeader: "Códigos de respaldo de la verificación en dos pasos — ORI",
	},
	disable: {
		title: "Desactivar la verificación en dos pasos",
		description:
			"Para confirmar, introduce un código de tu método de verificación o un código de respaldo.",
		codeLabel: "Código de verificación o respaldo",
	},
	regenerate: {
		title: "Regenerar códigos de respaldo",
		warning:
			"Al generar nuevos códigos, los códigos de respaldo anteriores dejarán de funcionar.",
		confirm: "Generar nuevos códigos",
	},
	devices: {
		title: "Dispositivos de confianza",
		empty: "Sin dispositivos de confianza",
		emptyHint:
			"Los dispositivos que recuerdas al iniciar sesión aparecen aquí y no piden el código durante 30 días.",
		unknownDevice: "Dispositivo desconocido",
		lastUsed: "Último uso",
		never: "Nunca",
		expires: "Caduca",
		revoked: "Dispositivo revocado",
		revokeError: "No se pudo revocar el dispositivo",
	},
	reminder: {
		title: "Protege tu cuenta",
		text: "Activa la verificación en dos pasos para una capa extra de seguridad al iniciar sesión.",
		activate: "Activar ahora",
		dismiss: "Descartar",
	},
	messages: {
		statusError: "No se pudo cargar el estado de la verificación en dos pasos",
		setupError: "No se pudo iniciar la configuración",
		activated: "Verificación en dos pasos activada con éxito",
		invalidCode: "Código inválido. Verifícalo e inténtalo de nuevo.",
		copied: "Copiado al portapapeles",
		copyError: "No se pudo copiar",
		disabled: "Verificación en dos pasos desactivada",
		regenerated: "Nuevos códigos de respaldo generados",
		regenerateError: "No se pudieron regenerar los códigos de respaldo",
	},
};
